import { render, staticRenderFns } from "./PricesMenuBtns.vue?vue&type=template&id=a8c564a2&scoped=true&"
import script from "./PricesMenuBtns.vue?vue&type=script&lang=js&"
export * from "./PricesMenuBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c564a2",
  null
  
)

export default component.exports